// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Grpql","loader":"Header_loader__QAo8W"};